import { Link } from "react-router-dom";

const SRC = {
  full: "/logo.svg", compact: "/logo-compact.svg", mark: "/logo-mark.svg",
  "full-white": "/logo-white.svg", "compact-white": "/logo-compact-white.svg", "mark-white": "/logo-mark-white.svg",
};
const RATIO = { full: 502 / 130, compact: 502 / 100, mark: 96 / 100 };

export const LogoImg = ({ variant = "compact", height = 40, className = "" }) => {
  const base = variant.replace("-white", "");
  return (
    <img src={SRC[variant]} alt="Habitalys" height={height} width={Math.round(height * RATIO[base])}
      style={{ height, width: "auto" }} className={`block select-none ${className}`} draggable="false" />
  );
};

export const Logo = ({ light = false, testid = "site-logo", variant = "compact", height = 34 }) => (
  <Link to="/" data-testid={testid} className="flex items-center shrink-0 transition-opacity hover:opacity-80" aria-label="Habitalys — accueil">
    <LogoImg variant={light ? `${variant}-white` : variant} height={height} />
  </Link>
);
